var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { 'icon-container': true }, _obj[_vm.type.toLowerCase()] = true, _obj )},[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }